import pick from 'lodash/pick';
import { paginationFields } from '@/models/pagination.model';
import { showApiErrors } from '@/utils';
import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { createGeneralFaq, deleteGeneralFaqs, getGeneralFaqs, updateGeneralFaq } from './actionCreators';
import { GeneralFaqState, SLICE_NAME, initialState } from './models';

export const generalFaqSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGeneralFaqs.fulfilled, (state: GeneralFaqState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.faqs = payload.faqs;
        state.pagination = pick(payload, paginationFields);
      })
      .addCase(updateGeneralFaq.fulfilled, (state: GeneralFaqState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.faqs = (state.faqs ?? []).map((faq) => (faq.faqId === payload.faqId ? payload : faq));
      })
      .addCase(deleteGeneralFaqs.fulfilled, (state: GeneralFaqState, action) => {
        const { meta } = action;
        state.isLoading = false;
        state.faqs = (state.faqs ?? []).filter((faq) => !meta.arg.faqIds.includes(faq.faqId));
        if (state.pagination) {
          state.pagination.total -= meta.arg.faqIds.length;
        }
      })
      .addCase(createGeneralFaq.fulfilled, (state: GeneralFaqState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.faqs = [payload, ...(state.faqs ?? [])];
        if (state.pagination) {
          state.pagination.total += 1;
        }
      })
      .addMatcher(
        isPending(createGeneralFaq, deleteGeneralFaqs, getGeneralFaqs, updateGeneralFaq),
        (state: GeneralFaqState) => {
          state.isLoading = true;
          state.error = null;
        },
      )
      .addMatcher(
        isRejected(createGeneralFaq, deleteGeneralFaqs, getGeneralFaqs, updateGeneralFaq),
        (state: GeneralFaqState, action) => {
          const { error } = action;

          state.isLoading = false;
          state.error = error;
          showApiErrors(error);
        },
      );
  },
});
